import React from "react";

import selectClose from "styles/common/img/gnb/selectclose.png";

function CloseButton(props) {
    const { handleClick } = props;

    return (
        <div className="selectclose" onClick={handleClick}>
            <img src={selectClose}></img>
        </div>
    );
}

export default CloseButton;
